module.exports = __webpack_public_path__ + "img/icon_tourism_vusu.590e720d.png";